import type { IconProps } from './types';
import './icons.css';

export default function Power({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 16}
      height={height || 16}
      viewBox="0 0 16 16"
      className={`icon icon-power ${className || ''}`}
      fill="none"
    >
      <path
        fill="currentColor"
        d="M11.774 2.601a.666.666 0 0 1 .933-.135 7.377 7.377 0 0 1 2.641 3.719 7.116 7.116 0 0 1-.101 4.514 7.41 7.41 0 0 1-2.805 3.603A7.877 7.877 0 0 1 8 15.666a7.874 7.874 0 0 1-4.442-1.364A7.41 7.41 0 0 1 .754 10.7a7.115 7.115 0 0 1-.102-4.514 7.376 7.376 0 0 1 2.64-3.719.667.667 0 0 1 .8 1.068 6.043 6.043 0 0 0-2.166 3.045 5.781 5.781 0 0 0 .083 3.669 6.077 6.077 0 0 0 2.302 2.954A6.54 6.54 0 0 0 8 14.333a6.543 6.543 0 0 0 3.69-1.131 6.078 6.078 0 0 0 2.302-2.954 5.781 5.781 0 0 0 .082-3.67 6.043 6.043 0 0 0-2.166-3.044.667.667 0 0 1-.134-.933ZM8 .333c.368 0 .667.3.667.667v6a.667.667 0 0 1-1.333 0V1c0-.368.298-.666.666-.667Z"
      />
    </svg>
  );
}
